<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <path d="M168.5 1.1c-34.8 2.2-56.4 6.8-76 16.4a165.7 165.7 0 0 0-80.8 89.1C5.8 123.7 2.9 141 1 171-.4 193.5-.4 646.5 1 669c2.4 37.9 6.6 58.3 16.5 78.5a165.7 165.7 0 0 0 89.1 80.8c17.1 5.9 34.4 8.8 64.4 10.7 22.5 1.4 475.5 1.4 498 0 37.9-2.4 58.3-6.6 78.5-16.5a165.7 165.7 0 0 0 80.8-89.1c5.9-17.1 8.8-34.4 10.7-64.4 1.4-22.5 1.4-475.5 0-498-2.4-37.9-6.6-58.3-16.5-78.5a165.7 165.7 0 0 0-89.1-80.8C716.3 5.8 699 2.9 669 1c-19.9-1.2-480.9-1.1-500.5.1zm271 262.3c24.8 6.7 42.5 24.8 53 54.6 8.2 22.9 11.7 47.5 15 105 3.7 64 9.7 88 22 88 13.9 0 18.9-16.8 25-83.5 3.9-42.8 6-57.6 11.1-77.6a144.1 144.1 0 0 1 31.3-63.1c8.9-9.9 30-24.4 32.2-22.1 1.2 1.2 28.9 58.6 28.9 59.9 0 .6-1.3 1.7-2.8 2.3-7.1 2.9-16.3 16-20.7 29-5.6 17.1-8.1 33.1-12.5 81.6a442 442 0 0 1-9.5 67.8C599.9 555 572.9 579 529.3 579c-41.5 0-67.4-23.3-80.2-72.5-5.1-19.2-7.8-42.9-10.6-90.5-2.6-44.7-5.6-65.9-11.1-78-3.1-6.9-5.4-9-9.9-9-11.4 0-17.2 25.8-20.5 91.5-4 79.2-13.4 113.9-36.9 137.6a53.6 53.6 0 0 1-17.1 12.7c-13.2 6.5-19 7.7-37 7.7-17.9 0-23.8-1.2-36.6-7.5-27-13.2-43.3-45.1-51.3-100.5-4.8-33-6.7-70.6-7.7-153.8l-.6-53.7H279v46.2c.1 124.6 6.7 187.1 21.1 199.3 4.1 3.4 8.8 3.3 12.4-.3 8.4-8.3 12.8-32.6 16-87.7 3.1-55.2 6.2-76.7 14.1-100.4 11-33.1 29.1-51.3 57.4-57.6 8.4-1.9 31-1.4 39.5.9z"/>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcySwileApp',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 840 840',
    },
  },
};
</script>

<style scoped>
  
</style>